// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseCustomerFactory instead of class inheritance

import { createBaseCustomer, type IBaseCustomer } from "../BaseCustomerFactory";
import type { NotesInstance } from "./helpers/notesInstanceHelpers";
import { createNotesInstance } from "./helpers/notesInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseCustomer, NotesInstance>({
	name: "Notes",
	createBase: createBaseCustomer,
	createInstance: createNotesInstance,
});

export function getNotesInstance(): NotesInstance {
	return factory.getInstance();
}
